/* eslint-disable react/prop-types */
import './index.scss';
import ModalBase from '.';
import { ModalProps } from '../../types';
import { useEffect, useState } from 'react';
import { Alert, Button, Input } from '@piggytechng/component-library';
import { OverideButtonStyle, OverideInputStyle } from '../../helpers/utils';
import useCustomers from '../../hooks/useCustomers';

function ModalCreditPiggypoint({ modalIsOpen, setIsOpen }: ModalProps) {
  const { creditPiggypoint, isLoading } = useCustomers();
  function closeModal() {
    if (isLoading) return;
    setIsOpen(false);
  }

  const [form, setForm] = useState({
    amount: null,
    reason: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!form.reason) {
      Alert.error('Please provide a reason for crediting points.');
      return;
    }

    if (form.amount === null || form.amount <= 0 || isNaN(form.amount)) {
      Alert.error('Please enter a valid amount.');
      return;
    }

    creditPiggypoint(form).then(() => {
      closeModal();
    });
  };

  useEffect(() => {
    setForm({
      amount: null,
      reason: '',
    });
  }, [modalIsOpen]);

  return (
    <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
      <div className={`modal-search`}>
        <div className="modal-search__header">
          <h2>Credit Points</h2>

          <button onClick={closeModal}>&times;</button>
        </div>

        <form className="modal-search__body" onSubmit={handleSubmit}>
          <Input
            {...OverideInputStyle}
            labelStyle={{
              color: '#666766',
            }}
            label="Enter amount"
            type="number"
            value={form.amount || ''}
            onChange={(e) => setForm({ ...form, amount: Number(e.target.value) as any })}
          />

          <Input
            {...OverideInputStyle}
            labelStyle={{
              color: '#666766',
            }}
            label="Enter reason"
            value={form.reason}
            onChange={(e) => setForm({ ...form, reason: e.target.value })}
          />

          <div className="modal-search__actions">
            <button className="modal-search__actions-reject" type="button" onClick={() => closeModal()}>
              Cancel
            </button>

            <Button {...OverideButtonStyle} className="modal-search__actions-resolve" type="submit" loading={isLoading}>
              Credit
            </Button>
          </div>
        </form>
      </div>
    </ModalBase>
  );
}

export default ModalCreditPiggypoint;
